import React from "react";
import { Button, Form, Row } from "react-bootstrap";
import DatePickerInput from "../../../components/common/DatePickerInput";

import DropDown from "../../../components/common/DropDown";
import ImgInput from "../../../components/common/ImgInput";
import InputText from "../../../components/form/inputText";
import InputSearchLocation from "../../../components/form/InputSearchLocation";
import { Enums } from "../../../constants";

export default function AddWizardOne({
  formInputs,
  setInput,
  formInputsErrors,
  onNextPress,
  durationList,
  serviceHoursList,
  timezoneList,
  propertyCategoryList,
  branchData,
  setFetchGuardAssociation,
  iniFetchGuardAssociation,
}) {
  // Functional update so the selected place never overwrites other fields with old values
  const handleLocation = (addressInfoArray) => {
    setInput((prevState) => ({
      ...prevState,
      address1: addressInfoArray.street_address,
      city: addressInfoArray.city,
      state: addressInfoArray.state,
      postal_code: addressInfoArray.postal_code,
      country: addressInfoArray.country,
      longitude: addressInfoArray.lng,
      latitude: addressInfoArray.lat,
    }));
  };

  return (
    <div className="bs-stepper-content p-4">
      <div className="content active dstepper-block">
        <div className="content-header"></div>
        <Form>
          <Row>
            <InputText
              type={"text"}
              title={"Property Name"}
              value={formInputs.property_name}
              onChange={(value) =>
                setInput({
                  ...formInputs,
                  property_name: value,
                })
              }
              required
              validationText={formInputsErrors.property_name}
            />
            <DropDown
              data={propertyCategoryList}
              title={"Category Type"}
              value={formInputs.property_category_type}
              onChange={(value) =>
                setInput({
                  ...formInputs,
                  property_category_type: value,
                })
              }
              validationText={formInputsErrors.property_category_type}
              required
            />
          </Row>
          <Row>
            <InputText
              type={"text"}
              title={"Number of Guards"}
              value={formInputs.no_of_guards}
              onChange={(value) =>
                setInput({
                  ...formInputs,
                  no_of_guards: value,
                })
              }
              required
              validationText={formInputsErrors.no_of_guards}
            />
            <InputText
              type="text"
              title="Number of Checkpoints"
              value={formInputs.no_of_checkpoints}
              onChange={(val) => {
                const cleaned = val.replace(/[^0-9]/g, "");
                if (cleaned === "") {
                  setInput({ ...formInputs, no_of_checkpoints: "" });
                  return;
                }
                const num = parseInt(cleaned, 10);
                if (num >= 1 && num <= 120) {
                  setInput({
                    ...formInputs,
                    no_of_checkpoints: num.toString(),
                  });
                }
              }}
              required
              validationText={formInputsErrors.no_of_checkpoints}
            />
          </Row>
          <Row>
            <InputText
              type={"number"}
              title={"Number of Patrolling in a day"}
              value={formInputs.no_of_patrolling_in_day}
              onChange={(value) =>
                setInput({
                  ...formInputs,
                  no_of_patrolling_in_day: value,
                })
              }
              required
              validationText={formInputsErrors.no_of_patrolling_in_day}
            />
            <DropDown
              data={timezoneList}
              title={"Timezone"}
              value={formInputs.timezone}
              onChange={(value) =>
                setInput({
                  ...formInputs,
                  timezone: value,
                })
              }
              validationText={formInputsErrors.timezone}
              required
            />
          </Row>
          <Row>
            <DropDown
              data={branchData}
              title={"Branch Manager"}
              value={formInputs.branch_id}
              onChange={(value) => {
                setInput({
                  ...formInputs,
                  branch_id: value,
                });

                if (value) {
                  setFetchGuardAssociation({
                    association_id: value,
                    association_type_term: Enums.UserRole.branch_manager,
                  });
                } else {
                  setFetchGuardAssociation(iniFetchGuardAssociation);
                }
              }}
              validationText={formInputsErrors.branch_id}
            />
            <DatePickerInput
              title={"Start Date"}
              selectedDate={formInputs.start_date}
              onChange={(value) => {
                setInput({
                  ...formInputs,
                  start_date: value,
                });
              }}
              validationText={formInputsErrors.start_date}
              required
            />
          </Row>
          <Row>
            <DropDown
              data={durationList}
              title={"Duration"}
              value={formInputs.duration_term}
              onChange={(value) =>
                setInput({
                  ...formInputs,
                  duration_term: value,
                })
              }
              validationText={formInputsErrors.duration_term}
              required
            />
            <DropDown
              data={serviceHoursList}
              value={formInputs.service_hours_term}
              title={"Service Hours"}
              onChange={(value) =>
                setInput({
                  ...formInputs,
                  service_hours_term: value,
                })
              }
              required
              validationText={formInputsErrors.service_hours_term}
            />
          </Row>
          <Row>
            <ImgInput
              title={"Property Image"}
              img_src={formInputs.property_img || null}
              input_ref_id="property_img"
              accept_file_type="image/*"
              onChange={(value) =>
                setInput((prevState) => ({
                  ...prevState,
                  property_img: value,
                }))
              }
            />
          </Row>
          <div className="col-12 row">
            <blockquote className="blockquote border-left-3 border-left-primary float-left pl-1 mt-3">
              <h4 className="mb-0 shop-title float-left">
                Location Details
              </h4>
            </blockquote>
          </div>
          <InputSearchLocation
            size={"12"}
            placeholder="Search location"
            onPlaceChange={handleLocation}
          />
          <Row>
            <InputText
              type={"text"}
              title={"Address"}
              value={formInputs.address1}
              onChange={(value) =>
                setInput({
                  ...formInputs,
                  address1: value,
                })
              }
              validationText={formInputsErrors.address1}
              required
            />
            <InputText
              type={"text"}
              title={"City"}
              value={formInputs.city}
              onChange={(value) =>
                setInput({
                  ...formInputs,
                  city: value,
                })
              }
              validationText={formInputsErrors.city}
              required
            />
          </Row>
          <Row>
            <InputText
              type={"text"}
              title={"State"}
              value={formInputs.state}
              onChange={(value) =>
                setInput({
                  ...formInputs,
                  state: value,
                })
              }
              validationText={formInputsErrors.state}
              required
            />
            <InputText
              type={"text"}
              title={"Postal code"}
              value={formInputs.postal_code}
              onChange={(value) =>
                setInput({
                  ...formInputs,
                  postal_code: value,
                })
              }
              validationText={formInputsErrors.postal_code}
              required
            />
          </Row>
          <Row>
            <InputText
              type={"text"}
              title={"Country"}
              value={formInputs.country}
              onChange={(value) =>
                setInput({
                  ...formInputs,
                  country: value,
                })
              }
              validationText={formInputsErrors.country}
              required
            />
          </Row>
          <Row>
            <div className="d-flex justify-content-between">
              <Button
                type="button"
                variant="outline-primary"
                className="disabled btn-15"
              >
                <i className="fa-regular fa-arrow-left"></i>{" "}
                <span className="align-middle d-sm-inline-block d-none">
                  Previous
                </span>
              </Button>
              <Button
                className="btn-15"
                variant="primary"
                onClick={onNextPress}
              >
                <span className="align-middle d-sm-inline-block d-none">
                  Next
                </span>{" "}
                <i className="fa-regular fa-arrow-right"></i>
              </Button>
            </div>
          </Row>
        </Form>
      </div>
    </div>
  );
}
